import { Injectable } from '@angular/core';

import {Router, NavigationEnd} from '@angular/router';

import { environment } from '../../environments/environment';

declare var ga: Function; // <-- Here we declare GA variable

@Injectable()
export class GoogleAnalyticsService {

  constructor(protected router: Router) {}

  subscribeGoogle(){
    if (!environment.production) {
    //    return;
    } // <-- If you want to enable GA only in production

    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {

        ga('set', 'page', event.url);

        ga('send', 'pageview');
       // console.log('%%% Google Analytics page view event %%%');
      }
    })
  }

}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/google-analytics.service.ts